import { render, staticRenderFns } from "./businessInfo_Change.vue?vue&type=template&id=2f176af8&scoped=true"
import script from "./businessInfo_Change.vue?vue&type=script&lang=js"
export * from "./businessInfo_Change.vue?vue&type=script&lang=js"
import style0 from "./businessInfo_Change.vue?vue&type=style&index=0&id=2f176af8&prod&lang=less&scoped=true"
import style1 from "./businessInfo_Change.vue?vue&type=style&index=1&id=2f176af8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f176af8",
  null
  
)

export default component.exports